/**
 * Common menu item notice generation methods used when building menu navigation
 * referenced server side in com.foretees.api.records.vueApp.enums.AppMenuNoticeGen
 */

function createResIssueNotice (vue) {
  const user = vue.$ftUser
  const issueCount = user && user.reservationIssueCount || 0
  if (issueCount > 0) {
    return [{text: '!', color: 'error', message: issueCount + ' reservation issue' + (issueCount > 1 ? 's' : '')}]
  } else {
    return []
  }
}

export default {
  reservationIssues (vue) {
    return createResIssueNotice(vue)
  },
}
